var items = {
  "block.minecraft.air": "һауа",
  "block.minecraft.stone": "таш",
  "block.minecraft.granite": "гранит",
  "block.minecraft.polished_granite": "шымартылған гранит",
  "block.minecraft.diorite": "диорит",
  "block.minecraft.polished_diorite": "шымартылған диорит",
  "block.minecraft.andesite": "андезит",
  "block.minecraft.polished_andesite": "шымартылған андезит",
  "block.minecraft.grass_block": "кәҫ",
  "block.minecraft.dirt": "тупраҡ",
  "block.minecraft.coarse_dirt": "ташлы тупраҡ",
  "block.minecraft.podzol": "көллөк",
  "block.minecraft.crimson_nylium": "бурлат нәҙмәклек",
  "block.minecraft.warped_nylium": "боҙолған нәҙмәклек",
  "block.minecraft.cobblestone": "суйырташ",
  "block.minecraft.oak_planks": "имән таҡталары",
  "block.minecraft.spruce_planks": "шыршы таҡталары",
  "block.minecraft.birch_planks": "ҡайын таҡталары",
  "block.minecraft.jungle_planks": "тропик ағас таҡталары",
  "block.minecraft.acacia_planks": "сәрүәр таҡталары",
  "block.minecraft.dark_oak_planks": "ҡара имән таҡталары",
  "block.minecraft.crimson_planks": "бурлат таҡталары",
  "block.minecraft.warped_planks": "боҙолған таҡталары",
  "block.minecraft.oak_sapling": "имән үҫентеһе",
  "block.minecraft.spruce_sapling": "шыршы үҫентеһе",
  "block.minecraft.birch_sapling": "ҡайын үҫентеһе",
  "block.minecraft.jungle_sapling": "тропик ағас үҫентеһе",
  "block.minecraft.acacia_sapling": "сәрүәр үҫентеһе",
  "block.minecraft.dark_oak_sapling": "ҡара имән үҫентеһе",
  "block.minecraft.bedrock": "бедрок",
  "block.minecraft.sand": "ҡом",
  "block.minecraft.red_sand": "ҡыҙыл ҡом",
  "block.minecraft.gravel": "ҡырсынташ",
  "block.minecraft.gold_ore": "алтын мәғдәне",
  "block.minecraft.iron_ore": "тимер мәғдәне",
  "block.minecraft.coal_ore": "ташкүмер",
  "block.minecraft.nether_gold_ore": "неҙер-алтын мәғдәне",
  "block.minecraft.oak_log": "имән бүрәнәһе",
  "block.minecraft.spruce_log": "шыршы бүрәнәһе",
  "block.minecraft.birch_log": "ҡайын бүрәнәһе",
  "block.minecraft.jungle_log": "тропик ағас бүрәнәһе",
  "block.minecraft.acacia_log": "сәрүәр бүрәнәһе",
  "block.minecraft.dark_oak_log": "ҡара имән бүрәнәһе",
  "block.minecraft.crimson_stem": "бурлат һабағы",
  "block.minecraft.warped_stem": "боҙолған һабаҡ",
  "block.minecraft.stripped_oak_log": "юнылған имән бүрәнәһе",
  "block.minecraft.stripped_spruce_log": "юнылған шыршы бүрәнәһе",
  "block.minecraft.stripped_birch_log": "юнылған ҡайын бүрәнәһе",
  "block.minecraft.stripped_jungle_log": "юнылған тропик ағас бүрәнәһе",
  "block.minecraft.stripped_acacia_log": "юнылған сәрүәр бүрәнәһе",
  "block.minecraft.stripped_dark_oak_log": "юнылған ҡара имән бүрәнәһе",
  "block.minecraft.stripped_crimson_stem": "таҙартылған бурлат һабағы",
  "block.minecraft.stripped_warped_stem": "таҙартылған боҙолған һабағы",
  "block.minecraft.stripped_oak_wood": "юнылған имән",
  "block.minecraft.stripped_spruce_wood": "юнылған шыршы",
  "block.minecraft.stripped_birch_wood": "юнылған ҡайын",
  "block.minecraft.stripped_jungle_wood": "юнылған тропик ағасы",
  "block.minecraft.stripped_acacia_wood": "юнылған сәрүәр",
  "block.minecraft.stripped_dark_oak_wood": "юнылған ҡара имән",
  "block.minecraft.stripped_crimson_hyphae": "таҙартылған бурлат һифалары",
  "block.minecraft.stripped_warped_hyphae": "таҙартылған боҙолған һифалары",
  "block.minecraft.oak_wood": "имән",
  "block.minecraft.spruce_wood": "шыршы",
  "block.minecraft.birch_wood": "ҡайын",
  "block.minecraft.jungle_wood": "тропик ағасы",
  "block.minecraft.acacia_wood": "сәрүәр",
  "block.minecraft.dark_oak_wood": "ҡара имән",
  "block.minecraft.crimson_hyphae": "бурлат һифалары",
  "block.minecraft.warped_hyphae": "боҙолған һифалары",
  "block.minecraft.oak_leaves": "имән япраҡтары",
  "block.minecraft.spruce_leaves": "шыршы япраҡтары",
  "block.minecraft.birch_leaves": "ҡайын япраҡтары",
  "block.minecraft.jungle_leaves": "тропик ағас япраҡтары",
  "block.minecraft.acacia_leaves": "сәрүәр япраҡтары",
  "block.minecraft.dark_oak_leaves": "ҡара имән япраҡтары",
  "block.minecraft.sponge": "болот",
  "block.minecraft.wet_sponge": "еүеш болот",
  "block.minecraft.glass": "быяла",
  "block.minecraft.lapis_ore": "рәжүәрт мәғдәне",
  "block.minecraft.lapis_block": "рәжүәрт ҡорамаһы",
  "block.minecraft.dispenser": "таратыусы",
  "block.minecraft.sandstone": "ҡомташ",
  "block.minecraft.chiseled_sandstone": "семәрле ҡомташ",
  "block.minecraft.cut_sandstone": "шыма ҡомташ",
  "block.minecraft.note_block": "ноталар ҡорамаһы",
  "block.minecraft.powered_rail": "ҡеүәтле тимер юл",
  "block.minecraft.detector_rail": "детекторлы тимер юл",
  "block.minecraft.sticky_piston": "йәбешкәк бешкәк",
  "block.minecraft.cobweb": "үрмәксе ауы",
  "block.minecraft.grass": "үлән",
  "block.minecraft.fern": "ҡаҙаяҡ",
  "block.minecraft.dead_bush": "үле ҡыуаҡ",
  "block.minecraft.seagrass": "диңгеҙ уләне",
  "block.minecraft.sea_pickle": "диңгеҙ ҡыяры",
  "block.minecraft.piston": "бешкәк",
  "block.minecraft.white_wool": "аҡ йөн",
  "block.minecraft.orange_wool": "ҡыҙғылт һары йөн",
  "block.minecraft.magenta_wool": "ҡуйы ҡыҙыл йөн",
  "block.minecraft.light_blue_wool": "зәңгәр йөн",
  "block.minecraft.yellow_wool": "һары йөн",
  "block.minecraft.lime_wool": "йәшкелт йөн",
  "block.minecraft.pink_wool": "алһыу йөн",
  "block.minecraft.gray_wool": "һоро йөн",
  "block.minecraft.light_gray_wool": "аҡһыл һоро йөн",
  "block.minecraft.cyan_wool": "фирүзә йөн",
  "block.minecraft.purple_wool": "шәмәхә йөн",
  "block.minecraft.blue_wool": "күк йөн",
  "block.minecraft.brown_wool": "көрән йөн",
  "block.minecraft.green_wool": "йәшел йөн",
  "block.minecraft.red_wool": "ҡыҙыл йөн",
  "block.minecraft.black_wool": "ҡара йөн",
  "block.minecraft.dandelion": "бәпембә",
  "block.minecraft.poppy": "мәк",
  "block.minecraft.blue_orchid": "күк орхидея",
  "block.minecraft.allium": "йыллау һуған",
  "block.minecraft.azure_bluet": "зәңгәр күк сәскә",
  "block.minecraft.red_tulip": "ҡыҙыл ләлә",
  "block.minecraft.orange_tulip": "ҡыҙғылт һары ләлә",
  "block.minecraft.white_tulip": "аҡ ләлә",
  "block.minecraft.pink_tulip": "алһыу ләлә",
  "block.minecraft.oxeye_daisy": "бабунәж",
  "block.minecraft.cornflower": "зәңгәр сәскә",
  "block.minecraft.lily_of_the_valley": "ынйы сәскә",
  "block.minecraft.wither_rose": "визер сәскә",
  "block.minecraft.brown_mushroom": "көрән бәшмәк",
  "block.minecraft.red_mushroom": "ҡыҙыл бәшмәк",
  "block.minecraft.crimson_fungus": "булат бәшмәк",
  "block.minecraft.warped_fungus": "боҙолған бәшмәк",
  "block.minecraft.crimson_roots": "бурлат тамырҙар",
  "block.minecraft.warped_roots": "боҙолған тамырҙар",
  "block.minecraft.nether_sprouts": "неҙер шытымы",
  "block.minecraft.weeping_vines": "илаҡсы сыбыҡ",
  "block.minecraft.twisting_vines": "сырмалыусан сыбыҡ",
  "block.minecraft.sugar_cane": "шәкәр ҡамышы",
  "block.minecraft.kelp": "диңгеҙ кәбеҫтәһе",
  "block.minecraft.bamboo": "бамбук",
  "block.minecraft.gold_block": "алтын ҡорамаһы",
  "block.minecraft.iron_block": "тимер ҡорамаһы",
  "block.minecraft.oak_slab": "имән плитаһы",
  "block.minecraft.spruce_slab": "шыршы плитаһы",
  "block.minecraft.birch_slab": "ҡайын плитаһы",
  "block.minecraft.jungle_slab": "тропик ағас плитаһы",
  "block.minecraft.acacia_slab": "сәрүәр плитаһы",
  "block.minecraft.dark_oak_slab": "ҡара имән плитаһы",
  "block.minecraft.crimson_slab": "бурлат плитаһы",
  "block.minecraft.warped_slab": "боҙолған плитаһы",
  "block.minecraft.stone_slab": "таш плитаһы",
  "block.minecraft.smooth_stone_slab": "шыма таш плитаһы",
  "block.minecraft.sandstone_slab": "ҡомташ плитаһы",
  "block.minecraft.cut_sandstone_slab": "шыма ҡомташ плитаһы",
  "block.minecraft.petrified_oak_slab": "ташҡа әйләнгән имән плита",
  "block.minecraft.cobblestone_slab": "суйырташ плитаһы",
  "block.minecraft.brick_slab": "кирбес плитаһы",
  "block.minecraft.stone_brick_slab": "таш кирбес плитаһы",
  "block.minecraft.nether_brick_slab": "неҙер кирбес плитаһы",
  "block.minecraft.quartz_slab": "кварц плитаһы",
  "block.minecraft.red_sandstone_slab": "ҡыҙыл ҡомташ плитаһы",
  "block.minecraft.cut_red_sandstone_slab": "шыма ҡыҙыл ҡомташ плитаһы",
  "block.minecraft.purpur_slab": "пурпур плитаһы",
  "block.minecraft.prismarine_slab": "призмарин плитаһы",
  "block.minecraft.prismarine_brick_slab": "призмарин кирбес плитаһы",
  "block.minecraft.dark_prismarine_slab": "ҡара призмарин плитаһы",
  "block.minecraft.smooth_quartz": "шыма кварц ҡорамаһы",
  "block.minecraft.smooth_red_sandstone": "шыма ҡыҙыл ҡомташ",
  "block.minecraft.smooth_sandstone": "шыма ҡомташ",
  "block.minecraft.smooth_stone": "шыма таш",
  "block.minecraft.bricks": "кирбестәр",
  "block.minecraft.tnt": "динамит",
  "block.minecraft.bookshelf": "китап кәштәһе",
  "block.minecraft.mossy_cobblestone": "мүкләнгән суйырташ",
  "block.minecraft.obsidian": "обсидиан",
  "block.minecraft.torch": "сыраҡ",
  "block.minecraft.end_rod": "энд үҙәге",
  "block.minecraft.chorus_plant": "хорус",
  "block.minecraft.chorus_flower": "хорус сәскәһе",
  "block.minecraft.purpur_block": "пурпур",
  "block.minecraft.purpur_pillar": "пурпур бағана",
  "block.minecraft.purpur_stairs": "пурпур баҫҡыстары",
  "block.minecraft.spawner": "үрсеткес",
  "block.minecraft.oak_stairs": "имән баҫҡыстары",
  "block.minecraft.chest": "һандыҡ",
  "block.minecraft.diamond_ore": "алмас мәғдәне",
  "block.minecraft.diamond_block": "алмас ҡорама",
  "block.minecraft.crafting_table": "эшкәртеү өҫтәле",
  "block.minecraft.farmland": "һөрөлгән ер",
  "block.minecraft.furnace": "мейес",
  "block.minecraft.ladder": "баҫҡыс",
  "block.minecraft.rail": "тимер юл",
  "block.minecraft.cobblestone_stairs": "суйырташ баҫҡыстары",
  "block.minecraft.lever": "һалмауыр",
  "block.minecraft.stone_pressure_plate": "таш ҡыҫым плитаһы",
  "block.minecraft.oak_pressure_plate": "имән ҡыҫым плитаһы",
  "block.minecraft.spruce_pressure_plate": "шыршы ҡыҫым плитаһы",
  "block.minecraft.birch_pressure_plate": "ҡайын ҡыҫым плитаһы",
  "block.minecraft.jungle_pressure_plate": "тропик ағас ҡыҫым плитаһы",
  "block.minecraft.acacia_pressure_plate": "сәрүәр ҡыҫым плитаһы",
  "block.minecraft.dark_oak_pressure_plate": "ҡара имән ҡыҫым плитаһы",
  "block.minecraft.crimson_pressure_plate": "бурлат ҡыҫым плитаһы",
  "block.minecraft.warped_pressure_plate": "боҙолған ҡыҫым плитаһы",
  "block.minecraft.polished_blackstone_pressure_plate": "шымартылған ҡараташ ҡыҫым плитаһы",
  "block.minecraft.redstone_ore": "редстоун мәғдәне",
  "block.minecraft.redstone_torch": "редстоун сырағы",
  "block.minecraft.snow": "ҡар",
  "block.minecraft.ice": "боҙ",
  "block.minecraft.snow_block": "ҡар ҡорамаһы",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "балсыҡ",
  "block.minecraft.jukebox": "уйнатҡыс",
  "block.minecraft.oak_fence": "имән ҡоймаһы",
  "block.minecraft.spruce_fence": "шыршы ҡоймаһы",
  "block.minecraft.birch_fence": "ҡайын ҡоймаһы",
  "block.minecraft.jungle_fence": "тропик ағас ҡоймаһы",
  "block.minecraft.acacia_fence": "сәрүәр ҡоймаһы",
  "block.minecraft.dark_oak_fence": "ҡара имән ҡоймаһы",
  "block.minecraft.crimson_fence": "бурлат ҡойма",
  "block.minecraft.warped_fence": "боҙолған ҡоймалар",
  "block.minecraft.pumpkin": "ҡабаҡ",
  "block.minecraft.carved_pumpkin": "киҫелгән ҡабаҡ",
  "block.minecraft.netherrack": "неҙерташ",
  "block.minecraft.soul_sand": "йәнле ҡом",
  "block.minecraft.soul_soil": "йәнле тупраҡ",
  "block.minecraft.basalt": "базальт",
  "block.minecraft.polished_basalt": "шымартылған базальт",
  "block.minecraft.soul_torch": "йәнле сырағы",
  "block.minecraft.glowstone": "яҡтыташ",
  "block.minecraft.jack_o_lantern": "джек шәме",
  "block.minecraft.oak_trapdoor": "имән люге",
  "block.minecraft.spruce_trapdoor": "диңгеҙ фонары",
  "block.minecraft.birch_trapdoor": "ҡайын люгы",
  "block.minecraft.jungle_trapdoor": "тропик ағас люгы",
  "block.minecraft.acacia_trapdoor": "сәрүәр люгы",
  "block.minecraft.dark_oak_trapdoor": "ҡара имән люгы",
  "block.minecraft.crimson_trapdoor": "бурлат люгы",
  "block.minecraft.warped_trapdoor": "боҙолған люгы",
  "block.minecraft.infested_stone": "ағыулы таш",
  "block.minecraft.infested_cobblestone": "ағыулы суйырташ",
  "block.minecraft.infested_stone_bricks": "ағыулы таш кирбестәре",
  "block.minecraft.infested_mossy_stone_bricks": "ағыулы мүкләнгән таш кирбестәре",
  "block.minecraft.infested_cracked_stone_bricks": "ағыулы ярылған таш кирбестәре",
  "block.minecraft.infested_chiseled_stone_bricks": "ағыулы семәрле таш кирбестәре",
  "block.minecraft.stone_bricks": "таш кирбестәре",
  "block.minecraft.mossy_stone_bricks": "мүкләнгән таш кирбестәре",
  "block.minecraft.cracked_stone_bricks": "ярылған таш кирбестәре",
  "block.minecraft.chiseled_stone_bricks": "семәрле таш кирбестәре",
  "block.minecraft.brown_mushroom_block": "көрән бәшмәк ҡорамы",
  "block.minecraft.red_mushroom_block": "ҡыҙыл бәшмәк ҡорамы",
  "block.minecraft.mushroom_stem": "бәшмәк һабағы",
  "block.minecraft.iron_bars": "тимер сыбыҡтар",
  "block.minecraft.chain": "сынйыр",
  "block.minecraft.glass_pane": "биҙәкле быяла",
  "block.minecraft.melon": "ҡарбуз",
  "block.minecraft.vine": "лианалар",
  "block.minecraft.oak_fence_gate": "имән ҡапҡаһы",
  "block.minecraft.spruce_fence_gate": "шыршы ҡапҡаһы",
  "block.minecraft.birch_fence_gate": "ҡайын ҡапҡаһы",
  "block.minecraft.jungle_fence_gate": "тропик ағас ҡапҡаһы",
  "block.minecraft.acacia_fence_gate": "сәрүәр ҡапҡаһы",
  "block.minecraft.dark_oak_fence_gate": "ҡара имән ҡапҡаһы",
  "block.minecraft.crimson_fence_gate": "бурлат ҡапҡа",
  "block.minecraft.warped_fence_gate": "боҙолған ҡапҡаһы",
  "block.minecraft.brick_stairs": "кирбес баҫҡыстары",
  "block.minecraft.stone_brick_stairs": "таш кирбес баҫҡыстары",
  "block.minecraft.mycelium": "бәшмәклек",
  "block.minecraft.lily_pad": "томбойоҡ",
  "block.minecraft.nether_bricks": "неҙер кирбестәре",
  "block.minecraft.cracked_nether_bricks": "ярылған неҙер кирбестәре",
  "block.minecraft.chiseled_nether_bricks": "семәрле неҙер кирбестәре",
  "block.minecraft.nether_brick_fence": "неҙер кирбес ҡоймаһы",
  "block.minecraft.nether_brick_stairs": "неҙер кирбес баҫҡыстары",
  "block.minecraft.enchanting_table": "сихырлау өҫтәле",
  "block.minecraft.end_portal_frame": "энд порталы ҡыҫанғы",
  "block.minecraft.end_stone": "эндерташ",
  "block.minecraft.end_stone_bricks": "эндерташ кирбестәре",
  "block.minecraft.dragon_egg": "аждаһа йомортҡаһы",
  "block.minecraft.redstone_lamp": "редстоун шәме",
  "block.minecraft.sandstone_stairs": "ҡомташ баҫҡыстары",
  "block.minecraft.emerald_ore": "зөбәржәт мәғдәне",
  "block.minecraft.ender_chest": "эндер-һандыҡ",
  "block.minecraft.tripwire_hook": "ырғаҡ",
  "block.minecraft.emerald_block": "зөбәржәт ҡорамаһы",
  "block.minecraft.spruce_stairs": "шыршы баҫҡыстары",
  "block.minecraft.birch_stairs": "ҡайын баҫҡыстары",
  "block.minecraft.jungle_stairs": "тропик ағас баҫҡыстары",
  "block.minecraft.crimson_stairs": "бурлат баҫҡыстар",
  "block.minecraft.warped_stairs": "боҙолған баҫҡыстар",
  "block.minecraft.command_block": "бойороҡ блогы",
  "block.minecraft.beacon": "маяҡ",
  "block.minecraft.cobblestone_wall": "суйырташ ҡоймаһы",
  "block.minecraft.mossy_cobblestone_wall": "мүкләнгән суйырташ ҡоймаһы",
  "block.minecraft.brick_wall": "кирбес ҡоймаһы",
  "block.minecraft.prismarine_wall": "призмарин ҡоймаһы",
  "block.minecraft.red_sandstone_wall": "ҡыҙыл ҡомташ ҡоймаһы",
  "block.minecraft.mossy_stone_brick_wall": "мүкләнгән таш кирбес ҡоймаһы",
  "block.minecraft.granite_wall": "гранит ҡоймаһы",
  "block.minecraft.stone_brick_wall": "таш кирбес ҡоймаһы",
  "block.minecraft.nether_brick_wall": "неҙер кирбес ҡоймаһы",
  "block.minecraft.andesite_wall": "андезит ҡоймаһы",
  "block.minecraft.red_nether_brick_wall": "ҡыҙыл неҙер кирбес ҡоймаһы",
  "block.minecraft.sandstone_wall": "ҡомташ ҡоймаһы",
  "block.minecraft.end_stone_brick_wall": "эндерташ кирбес ҡоймаһы",
  "block.minecraft.diorite_wall": "диорит ҡоймаһы",
  "block.minecraft.blackstone_wall": "ҡараташ ҡоймаһы",
  "block.minecraft.polished_blackstone_wall": "шымартылған ҡараташ ҡоймаһы",
  "block.minecraft.polished_blackstone_brick_wall": "шымартылған ҡараташ кирбес ҡоймаһы",
  "block.minecraft.stone_button": "таш төймә",
  "block.minecraft.oak_button": "имән төймәһе",
  "block.minecraft.spruce_button": "шыршы төймәһе",
  "block.minecraft.birch_button": "ҡайын төймәһе",
  "block.minecraft.jungle_button": "тропик ағас төймәһе",
  "block.minecraft.acacia_button": "сәрүәр төймәһе",
  "block.minecraft.dark_oak_button": "ҡара имән төймәһе",
  "block.minecraft.crimson_button": "бурлат төймә",
  "block.minecraft.warped_button": "боҙолған төймә",
  "block.minecraft.polished_blackstone_button": "шымартылған ҡараташ төймәһе",
  "block.minecraft.anvil": "һандал",
  "block.minecraft.chipped_anvil": "боҙылған һандал",
  "block.minecraft.damaged_anvil": "ватылған һандал",
  "block.minecraft.trapped_chest": "ҡапҡан-һандыҡ",
  "block.minecraft.light_weighted_pressure_plate": "ауырлыҡ плитаһы",
  "block.minecraft.heavy_weighted_pressure_plate": "ауыр йөклө ауырлыҡ плитаһы",
  "block.minecraft.daylight_detector": "көндөҙгө яҡтылыҡ датчигы",
  "block.minecraft.redstone_block": "редстоун ҡорамаһы",
  "block.minecraft.nether_quartz_ore": "неҙер-кварц мәғдәне",
  "block.minecraft.hopper": "буранка",
  "block.minecraft.chiseled_quartz_block": "семәрле кварц ҡорамаһы",
  "block.minecraft.quartz_block": "кварц ҡорамаһы",
  "block.minecraft.quartz_bricks": "кварц кирбестәре",
  "block.minecraft.quartz_pillar": "кварц бағанаһы",
  "block.minecraft.quartz_stairs": "кварц баҫҡыстары",
  "block.minecraft.activator_rail": "әүҙемләткес тимер юл",
  "block.minecraft.dropper": "ташлатҡыс",
  "block.minecraft.white_terracotta": "аҡ яндырығашы",
  "block.minecraft.orange_terracotta": "ҡыҙғылт яндырығашы",
  "block.minecraft.magenta_terracotta": "ҡуйы ҡыҙыл яндырығашы",
  "block.minecraft.light_blue_terracotta": "зәңгәр яндырығашы",
  "block.minecraft.yellow_terracotta": "һары яндырығашы",
  "block.minecraft.lime_terracotta": "йәшкелт яндырығашы",
  "block.minecraft.pink_terracotta": "алһыу яндырығашы",
  "block.minecraft.gray_terracotta": "һоро яндырығашы",
  "block.minecraft.light_gray_terracotta": "аҡһыл һоро яндырығашы",
  "block.minecraft.cyan_terracotta": "фирүзә яндырығашы",
  "block.minecraft.purple_terracotta": "шәмәхә яндырығашы",
  "block.minecraft.blue_terracotta": "күк яндырығашы",
  "block.minecraft.brown_terracotta": "көрән яндырығашы",
  "block.minecraft.green_terracotta": "йәшел яндырығашы",
  "block.minecraft.red_terracotta": "ҡыҙыл яндырығашы",
  "block.minecraft.black_terracotta": "ҡара яндырығашы",
  "block.minecraft.barrier": "тотҡарлыҡ",
  "block.minecraft.iron_trapdoor": "тимер люгы",
  "block.minecraft.hay_block": "бесән көлтәһе",
  "block.minecraft.white_carpet": "аҡ келәм",
  "block.minecraft.orange_carpet": "ҡыҙғылт һары келәм",
  "block.minecraft.magenta_carpet": "ҡуйы ҡыҙыл келәм",
  "block.minecraft.light_blue_carpet": "зәңгәр келәм",
  "block.minecraft.yellow_carpet": "һары келәм",
  "block.minecraft.lime_carpet": "йәшкелт келәм",
  "block.minecraft.pink_carpet": "алһыу келәм",
  "block.minecraft.gray_carpet": "һоро келәм",
  "block.minecraft.light_gray_carpet": "аҡһыл һоро келәм",
  "block.minecraft.cyan_carpet": "фирүзә келәм",
  "block.minecraft.purple_carpet": "шәмәхә келәм",
  "block.minecraft.blue_carpet": "күк келәм",
  "block.minecraft.brown_carpet": "көрән келәм",
  "block.minecraft.green_carpet": "йәшел келәм",
  "block.minecraft.red_carpet": "ҡыҙыл келәм",
  "block.minecraft.black_carpet": "ҡара келәм",
  "block.minecraft.terracotta": "терракота",
  "block.minecraft.coal_block": "күмер ҡорама",
  "block.minecraft.packed_ice": "ҡалын боҙ",
  "block.minecraft.acacia_stairs": "сәрүәр баҫҡыстары",
  "block.minecraft.dark_oak_stairs": "ҡара имән баҫҡыстары",
  "block.minecraft.slime_block": "лайлас ҡорамаһы",
  "block.minecraft.grass_path": "һуҡмаҡ",
  "block.minecraft.sunflower": "көнбағыш",
  "block.minecraft.lilac": "күксин",
  "block.minecraft.rose_bush": "роза ҡыуағы",
  "block.minecraft.peony": "дөр-дөр",
  "block.minecraft.tall_grass": "бейек үлән",
  "block.minecraft.large_fern": "эре ҡаҙаяҡ",
  "block.minecraft.white_stained_glass": "аҡ быяла",
  "block.minecraft.orange_stained_glass": "ҡыҙғылт һары быяла",
  "block.minecraft.magenta_stained_glass": "ҡуйы ҡыҙыл быяла",
  "block.minecraft.light_blue_stained_glass": "зәңгәр быяла",
  "block.minecraft.yellow_stained_glass": "һары быяла",
  "block.minecraft.lime_stained_glass": "йәшкелт быяла",
  "block.minecraft.pink_stained_glass": "алһыу быяла",
  "block.minecraft.gray_stained_glass": "һоро быяла",
  "block.minecraft.light_gray_stained_glass": "аҡһыл һоро быяла",
  "block.minecraft.cyan_stained_glass": "фирүзә быяла",
  "block.minecraft.purple_stained_glass": "шәмәхә быяла",
  "block.minecraft.blue_stained_glass": "күк быяла",
  "block.minecraft.brown_stained_glass": "көрән быяла",
  "block.minecraft.green_stained_glass": "йәшел быяла",
  "block.minecraft.red_stained_glass": "ҡыҙыл быяла",
  "block.minecraft.black_stained_glass": "ҡара быяла",
  "block.minecraft.white_stained_glass_pane": "аҡ биҙәкле быяла",
  "block.minecraft.orange_stained_glass_pane": "ҡыҙғылт һары биҙәкле быяла",
  "block.minecraft.magenta_stained_glass_pane": "ҡуйы ҡыҙыл биҙәкле быяла",
  "block.minecraft.light_blue_stained_glass_pane": "зәңгәр биҙәкле быяла",
  "block.minecraft.yellow_stained_glass_pane": "һары биҙәкле быяла",
  "block.minecraft.lime_stained_glass_pane": "йәшкелт биҙәкле быяла",
  "block.minecraft.pink_stained_glass_pane": "алһыу биҙәкле быяла",
  "block.minecraft.gray_stained_glass_pane": "һоро биҙәкле быяла",
  "block.minecraft.light_gray_stained_glass_pane": "аҡһыл һоро биҙәкле быяла",
  "block.minecraft.cyan_stained_glass_pane": "фирүзә биҙәкле быяла",
  "block.minecraft.purple_stained_glass_pane": "шәмәхә биҙәкле быяла",
  "block.minecraft.blue_stained_glass_pane": "күк биҙәкле быяла",
  "block.minecraft.brown_stained_glass_pane": "көрән биҙәкле быяла",
  "block.minecraft.green_stained_glass_pane": "йәшел биҙәкле быяла",
  "block.minecraft.red_stained_glass_pane": "ҡыҙыл биҙәкле быяла",
  "block.minecraft.black_stained_glass_pane": "ҡара биҙәкле быяла",
  "block.minecraft.prismarine": "призмарин",
  "block.minecraft.prismarine_bricks": "призмарин кирбестәре",
  "block.minecraft.dark_prismarine": "ҡара призмарин",
  "block.minecraft.prismarine_stairs": "призмарин баҫҡыстары",
  "block.minecraft.prismarine_brick_stairs": "призмарин кирбес баҫҡыстары",
  "block.minecraft.dark_prismarine_stairs": "ҡара призмарин баҫҡыстары",
  "block.minecraft.sea_lantern": "диңгеҙ фонары",
  "block.minecraft.red_sandstone": "ҡыҙыл ҡомташ",
  "block.minecraft.chiseled_red_sandstone": "семәрле ҡыҙыл ҡомташ",
  "block.minecraft.cut_red_sandstone": "шыма ҡыҙыл ҡомташ",
  "block.minecraft.red_sandstone_stairs": "ҡыҙыл ҡомташ баҫҡыстары",
  "block.minecraft.repeating_command_block": "ҡабатланған бойороҡ блогы",
  "block.minecraft.chain_command_block": "эҙмә-эҙлекле бойороҡ блогы",
  "block.minecraft.magma_block": "магма",
  "block.minecraft.nether_wart_block": "неҙер ҡатламының ҡорамаһы",
  "block.minecraft.warped_wart_block": "боҙолған ҡатлам ҡорамаһы",
  "block.minecraft.red_nether_bricks": "ҡыҙыл неҙер кирбесе",
  "block.minecraft.bone_block": "һөйәк ҡорамаһы",
  "block.minecraft.structure_void": "буш ҡорамаһы",
  "block.minecraft.observer": "күҙәтеүсе",
  "block.minecraft.shulker_box": "шалкер тартмаһы",
  "block.minecraft.white_shulker_box": "аҡ шалкер тартмаһы",
  "block.minecraft.orange_shulker_box": "ҡыҙғылт шалкер тартмаһы",
  "block.minecraft.magenta_shulker_box": "ҡуйы ҡыҙыл шалкер тартмаһы",
  "block.minecraft.light_blue_shulker_box": "зәңгәр шалкер тартмаһы",
  "block.minecraft.yellow_shulker_box": "һары шалкер тартмаһы",
  "block.minecraft.lime_shulker_box": "йәшкелт шалкер тартмаһы",
  "block.minecraft.pink_shulker_box": "алһыу шалкер тартмаһы",
  "block.minecraft.gray_shulker_box": "һоро шалкер тартмаһы",
  "block.minecraft.light_gray_shulker_box": "аҡһыл һоро шалкер тартмаһы",
  "block.minecraft.cyan_shulker_box": "фирүзә шалкер тартмаһы",
  "block.minecraft.purple_shulker_box": "шәмәхә шалкер тартмаһы",
  "block.minecraft.blue_shulker_box": "күк шалкер тартмаһы",
  "block.minecraft.brown_shulker_box": "көрән шалкер тартмаһы",
  "block.minecraft.green_shulker_box": "йәшел шалкер тартмаһы",
  "block.minecraft.red_shulker_box": "ҡыҙыл шалкер тартмаһы",
  "block.minecraft.black_shulker_box": "ҡара шалкер тартмаһы",
  "block.minecraft.white_glazed_terracotta": "аҡ шалкер тартмаһы",
  "block.minecraft.orange_glazed_terracotta": "ҡыҙғылт шалкер тартмаһы",
  "block.minecraft.magenta_glazed_terracotta": "ҡуйы ҡыҙыл шалкер тартмаһы",
  "block.minecraft.light_blue_glazed_terracotta": "зәңгәр шалкер тартмаһы",
  "block.minecraft.yellow_glazed_terracotta": "һары ялтырауыҡлы яндырығашы",
  "block.minecraft.lime_glazed_terracotta": "йәшкелт ялтырауыҡлы яндырығашы",
  "block.minecraft.pink_glazed_terracotta": "алһыу ялтырауыҡлы яндырығашы",
  "block.minecraft.gray_glazed_terracotta": "һоро ялтырауыҡлы яндырығашы",
  "block.minecraft.light_gray_glazed_terracotta": "аҡһыл һоро ялтырауыҡлы яндырығашы",
  "block.minecraft.cyan_glazed_terracotta": "фирүзә ялтырауыҡлы яндырығашы",
  "block.minecraft.purple_glazed_terracotta": "шәмәхә ялтырауыҡлы яндырығашы",
  "block.minecraft.blue_glazed_terracotta": "күк ялтырауыҡлы яндырығашы",
  "block.minecraft.brown_glazed_terracotta": "көрән ялтырауыҡлы яндырығашы",
  "block.minecraft.green_glazed_terracotta": "йәшел ялтырауыҡлы яндырығашы",
  "block.minecraft.red_glazed_terracotta": "ҡыҙыл ялтырауыҡлы яндырығашы",
  "block.minecraft.black_glazed_terracotta": "ҡара ялтырауыҡлы яндырығашы",
  "block.minecraft.white_concrete": "аҡ бетон",
  "block.minecraft.orange_concrete": "ҡыҙғылт һары бетон",
  "block.minecraft.magenta_concrete": "ҡуйы ҡыҙыл бетон",
  "block.minecraft.light_blue_concrete": "зәңгәр бетон",
  "block.minecraft.yellow_concrete": "һары бетон",
  "block.minecraft.lime_concrete": "йәшкелт бетон",
  "block.minecraft.pink_concrete": "алһыу бетон",
  "block.minecraft.gray_concrete": "һоро бетон",
  "block.minecraft.light_gray_concrete": "аҡһыл һоро бетон",
  "block.minecraft.cyan_concrete": "фирүзә бетон",
  "block.minecraft.purple_concrete": "шәмәхә бетон",
  "block.minecraft.blue_concrete": "күк бетон",
  "block.minecraft.brown_concrete": "көрән бетон",
  "block.minecraft.green_concrete": "йәшел бетон",
  "block.minecraft.red_concrete": "ҡыҙыл бетон",
  "block.minecraft.black_concrete": "ҡара бетон",
  "block.minecraft.white_concrete_powder": "аҡ ҡоро бетон",
  "block.minecraft.orange_concrete_powder": "ҡыҙғылт һары ҡоро бетон",
  "block.minecraft.magenta_concrete_powder": "ҡуйы ҡыҙыл ҡоро бетон",
  "block.minecraft.light_blue_concrete_powder": "зәңгәр ҡоро бетон",
  "block.minecraft.yellow_concrete_powder": "һары ҡоро бетон",
  "block.minecraft.lime_concrete_powder": "йәшкелт ҡоро бетон",
  "block.minecraft.pink_concrete_powder": "алһыу ҡоро бетон",
  "block.minecraft.gray_concrete_powder": "һоро ҡоро бетон",
  "block.minecraft.light_gray_concrete_powder": "аҡһыл һоро ҡоро бетон",
  "block.minecraft.cyan_concrete_powder": "фирүзә ҡоро бетон",
  "block.minecraft.purple_concrete_powder": "шәмәхә ҡоро бетон",
  "block.minecraft.blue_concrete_powder": "күк ҡоро бетон",
  "block.minecraft.brown_concrete_powder": "көрән ҡоро бетон",
  "block.minecraft.green_concrete_powder": "йәшел ҡоро бетон",
  "block.minecraft.red_concrete_powder": "ҡыҙыл ҡоро бетон",
  "block.minecraft.black_concrete_powder": "ҡара ҡоро бетон",
  "block.minecraft.turtle_egg": "гөбөргәйел йомортҡаһы",
  "block.minecraft.dead_tube_coral_block": "үле көпшәк мәрйен ҡорамаһы",
  "block.minecraft.dead_brain_coral_block": "үле мейе мәрйен ҡорамаһы",
  "block.minecraft.dead_bubble_coral_block": "үле күбек мәрйен ҡорамаһы",
  "block.minecraft.dead_fire_coral_block": "үле утлы мәрйен ҡорамаһы",
  "block.minecraft.dead_horn_coral_block": "үле мөгөҙлө мәрйен ҡорамаһы",
  "block.minecraft.tube_coral_block": "көпшәле мәрйен ҡорамаһы",
  "block.minecraft.brain_coral_block": "мейе мәрйен ҡорамаһы",
  "block.minecraft.bubble_coral_block": "күбек мәрйен ҡорамаһы",
  "block.minecraft.fire_coral_block": "утлы мәрйен ҡорамаһы",
  "block.minecraft.horn_coral_block": "мөгөҙлө мәрйен ҡорамаһы",
  "block.minecraft.tube_coral": "көпшәле мәрйен",
  "block.minecraft.brain_coral": "мейе мәрйен",
  "block.minecraft.bubble_coral": "ҡыуыҡлы мәрйен",
  "block.minecraft.fire_coral": "утлы мәрйен",
  "block.minecraft.horn_coral": "мөгөҙлө мәрйен",
  "block.minecraft.dead_brain_coral": "үле мейе мәрйен",
  "block.minecraft.dead_bubble_coral": "үле ҡыуыҡлы мәрйен",
  "block.minecraft.dead_fire_coral": "үле утлы мәрйен",
  "block.minecraft.dead_horn_coral": "үле мөгөҙлө мәрйен",
  "block.minecraft.dead_tube_coral": "үле көпшәк мәрйен",
  "block.minecraft.tube_coral_fan": "елпеүесле көпшәлек мәрйен",
  "block.minecraft.brain_coral_fan": "елпеүесле мейе мәрйен",
  "block.minecraft.bubble_coral_fan": "елпеүесле ҡыуыҡлы мәрйен",
  "block.minecraft.fire_coral_fan": "елпеүесле утлы мәрйен",
  "block.minecraft.horn_coral_fan": "елпеүесле мөгөҙлө мәрйен",
  "block.minecraft.dead_tube_coral_fan": "үле елпеүесле көпшәле мәрйен",
  "block.minecraft.dead_brain_coral_fan": "үле елпеүесле мейе мәрйен",
  "block.minecraft.dead_bubble_coral_fan": "үле елпеүесле ҡыуыҡлы мәрйен",
  "block.minecraft.dead_fire_coral_fan": "үле елпеүесле утлыҡ мәрйен",
  "block.minecraft.dead_horn_coral_fan": "үле елпеүесле мөгөҙлө мәрйен",
  "block.minecraft.blue_ice": "күк боҙ",
  "block.minecraft.conduit": "диңгеҙ сығанағы",
  "block.minecraft.polished_granite_stairs": "шымартылған гранит баҫҡыстары",
  "block.minecraft.smooth_red_sandstone_stairs": "шыма ҡыҙыл ҡомташ баҫҡыстары",
  "block.minecraft.mossy_stone_brick_stairs": "мүкләнгән таш кирбестәр баҫҡыстары",
  "block.minecraft.polished_diorite_stairs": "шымартылған диорит баҫҡыстары",
  "block.minecraft.mossy_cobblestone_stairs": "мүкләнгән суйырташ баҫҡыстары",
  "block.minecraft.end_stone_brick_stairs": "эндерташ кирбестәр баҫҡыстары",
  "block.minecraft.stone_stairs": "таш баҫҡыстары",
  "block.minecraft.smooth_sandstone_stairs": "шыма ҡомташ баҫҡыстары",
  "block.minecraft.smooth_quartz_stairs": "шыма кварц баҫҡыстары",
  "block.minecraft.granite_stairs": "гранит баҫҡыстары",
  "block.minecraft.andesite_stairs": "андезит баҫҡыстары",
  "block.minecraft.red_nether_brick_stairs": "ҡыҙыл неҙер кирбес баҫҡыстары",
  "block.minecraft.polished_andesite_stairs": "шымартылған андезит баҫҡыстары",
  "block.minecraft.diorite_stairs": "диорит баҫҡыстары",
  "block.minecraft.polished_granite_slab": "шымартылған гранит баҫҡыстары",
  "block.minecraft.smooth_red_sandstone_slab": "шыма ҡыҙыл ҡомташ баҫҡыстары",
  "block.minecraft.mossy_stone_brick_slab": "мүкләнгән таш кирбес плитаһы",
  "block.minecraft.polished_diorite_slab": "шымартылған диорит плитаһы",
  "block.minecraft.mossy_cobblestone_slab": "мүкләнгән суйырташ плитаһы",
  "block.minecraft.end_stone_brick_slab": "эндерташ кирбес плитаһы",
  "block.minecraft.smooth_sandstone_slab": "шыма ҡомташ плитаһы",
  "block.minecraft.smooth_quartz_slab": "шыма кварц плитаһы",
  "block.minecraft.granite_slab": "гранит плитаһы",
  "block.minecraft.andesite_slab": "андезит плитаһы",
  "block.minecraft.red_nether_brick_slab": "ҡыҙыл неҙер кирбес плитаһы",
  "block.minecraft.polished_andesite_slab": "шымартылған андезит плитаһы",
  "block.minecraft.diorite_slab": "диорит плитаһы",
  "block.minecraft.scaffolding": "баҫма",
  "block.minecraft.iron_door": "тимер ишек",
  "block.minecraft.oak_door": "имән ишеге",
  "block.minecraft.spruce_door": "шыршы ишеге",
  "block.minecraft.birch_door": "ҡайын ишеге",
  "block.minecraft.jungle_door": "тропик ағас ишеге",
  "block.minecraft.acacia_door": "сәрүәр ишеге",
  "block.minecraft.dark_oak_door": "ҡара имән ишеге",
  "block.minecraft.crimson_door": "бурлат ишек",
  "block.minecraft.warped_door": "боҙолған ишек",
  "block.minecraft.repeater": "редстоун ҡабатлағысы",
  "block.minecraft.comparator": "редстоун сағыштырғысы",
  "block.minecraft.structure_block": "структуралыҡ ҡорамаһы",
  "block.minecraft.jigsaw": "пазл",
  "item.minecraft.turtle_helmet": "гөбөргәйелдең ҡабығы□□башта:□+2 ҡояҡ",
  "item.minecraft.scute": "ҡалҡанса",
  "item.minecraft.iron_shovel": "тимер көрәк□□төп ҡулда:□+3.5 зыян□-3 һөжүм тиҙлек",
  "item.minecraft.iron_pickaxe": "тимер кәйлә□□төп ҡулда:□+3 зыян□-2.8 һөжүм тиҙлек",
  "item.minecraft.iron_axe": "тимер балта□□төп ҡулда:□+8 зыян□-3.1 һөжүм тиҙлек",
  "item.minecraft.flint_and_steel": "саҡма",
  "item.minecraft.apple": "алма",
  "item.minecraft.bow": "йәйә",
  "item.minecraft.arrow": "уҡ",
  "item.minecraft.coal": "күмер",
  "item.minecraft.charcoal": "ағас күмере",
  "item.minecraft.diamond": "алмас",
  "item.minecraft.iron_ingot": "тимер ҡойолма",
  "item.minecraft.gold_ingot": "алтын ҡойолма",
  "item.minecraft.netherite_ingot": "неҙерит ҡойолмаһы",
  "item.minecraft.netherite_scrap": "неҙерит вайранлығы",
  "item.minecraft.iron_sword": "тимер ҡылыс□□төп ҡулда:□+5 зыян□-2.4 һөжүм тиҙлек",
  "item.minecraft.wooden_sword": "ағас ҡылыс□□төп ҡулда:□+3 зыян□-2.4 һөжүм тиҙлек",
  "item.minecraft.wooden_shovel": "ағас көрәк□□төп ҡулда:□+1.5 зыян□-3 һөжүм тиҙлек",
  "item.minecraft.wooden_pickaxe": "ағас кәйлә□□төп ҡулда:□+1 зыян□-2.8 һөжүм тиҙлек",
  "item.minecraft.wooden_axe": "ағас балта□□төп ҡулда:□+6 зыян□-3.2 һөжүм тиҙлек",
  "item.minecraft.stone_sword": "таш ҡылыс□□төп ҡулда:□+4 зыян□-2.4 һөжүм тиҙлек",
  "item.minecraft.stone_shovel": "таш көрәк□□төп ҡулда:□+2.5 зыян□-3 һөжүм тиҙлек",
  "item.minecraft.stone_pickaxe": "таш кәйлә□□төп ҡулда:□+2 зыян□-2.8 һөжүм тиҙлек",
  "item.minecraft.stone_axe": "таш балта□□төп ҡулда:□+8 зыян□-3.2 һөжүм тиҙлек",
  "item.minecraft.diamond_sword": "алмас ҡылыс□□төп ҡулда:□+6 зыян□-2.4 һөжүм тиҙлек",
  "item.minecraft.diamond_shovel": "алмас көрәк□□төп ҡулда:□+4.5 зыян□-3 һөжүм тиҙлек",
  "item.minecraft.diamond_pickaxe": "алмас кәйлә□□төп ҡулда:□+4 зыян□-2.8 һөжүм тиҙлек",
  "item.minecraft.diamond_axe": "алмас балта□□төп ҡулда:□+8 зыян□-3 һөжүм тиҙлек",
  "item.minecraft.stick": "таяҡ",
  "item.minecraft.bowl": "туҫтаҡ",
  "item.minecraft.mushroom_stew": "быҡтырылған бәшмәк",
  "item.minecraft.golden_sword": "алтын ҡылыс□□төп ҡулда:□+3 зыян□-2.4 һөжүм тиҙлек",
  "item.minecraft.golden_shovel": "алтын көрәк□□төп ҡулда:□+1.5 зыян□-3 һөжүм тиҙлек",
  "item.minecraft.golden_pickaxe": "алытын кәйлә□□төп ҡулда:□+1 зыян□-2.8 һөжүм тиҙлек",
  "item.minecraft.golden_axe": "алтын балта□□төп ҡулда:□+6 зыян□-3 һөжүм тиҙлек",
  "item.minecraft.netherite_sword": "неҙерит ҡылысы□□төп ҡулда:□+7 зыян□-2.4 һөжүм тиҙлек",
  "item.minecraft.netherite_shovel": "неҙерит көрәге□□төп ҡулда:□+5.5 зыян□-3 һөжүм тиҙлек",
  "item.minecraft.netherite_pickaxe": "неҙерит кәйләһе□□төп ҡулда:□+5 зыян□-2.8 һөжүм тиҙлек",
  "item.minecraft.netherite_axe": "неҙерит балтаһы□□төп ҡулда:□+9 зыян□-3 һөжүм тиҙлек",
  "item.minecraft.string": "еп",
  "item.minecraft.feather": "ҡауырһын",
  "item.minecraft.gunpowder": "дары",
  "item.minecraft.wooden_hoe": "ағас тәпке□□төп ҡулда:□-3 һөжүм тиҙлек",
  "item.minecraft.stone_hoe": "таш тәпке□□төп ҡулда:□-2 һөжүм тиҙлек",
  "item.minecraft.iron_hoe": "тимер тәпке□□төп ҡулда:□-1 һөжүм тиҙлек",
  "item.minecraft.diamond_hoe": "алмас тәпке□□төп ҡулда:",
  "item.minecraft.golden_hoe": "алтын тәпке□□төп ҡулда:□-3 һөжүм тиҙлек",
  "item.minecraft.netherite_hoe": "неҙерит тәпке□□төп ҡулда:",
  "item.minecraft.wheat_seeds": "бойҙай орлоҡтары",
  "item.minecraft.wheat": "бойҙай",
  "item.minecraft.bread": "икмәк",
  "item.minecraft.leather_helmet": "күн торҡа□□башта:□+1 ҡояҡ",
  "item.minecraft.leather_chestplate": "күн бәрте□□тәндә:□+3 ҡояҡ",
  "item.minecraft.leather_leggings": "күн салбар□□аяҡта:□+2 ҡояҡ",
  "item.minecraft.leather_boots": "күн итек□□үксәлә:□+1 ҡояҡ",
  "item.minecraft.chainmail_helmet": "койф□□башта:□+2 ҡояҡ",
  "item.minecraft.chainmail_chestplate": "һайман□□тәндә:□+5 ҡояҡ",
  "item.minecraft.chainmail_leggings": "һайман салбар□□аяҡта:□+4 ҡояҡ",
  "item.minecraft.chainmail_boots": "һайман итек□□үксәлә:□+1 ҡояҡ",
  "item.minecraft.iron_helmet": "тимер торҡа□□башта:□+2 ҡояҡ",
  "item.minecraft.iron_chestplate": "тимер күкрәксә□□тәндә:□+6 ҡояҡ",
  "item.minecraft.iron_leggings": "тимер салбар□□аяҡта:□+5 ҡояҡ",
  "item.minecraft.iron_boots": "тимер итек□□үксәлә:□+2 ҡояҡ",
  "item.minecraft.diamond_helmet": "алмас торҡа□□башта:□+3 ҡояҡ□+2 ҡояҡ ныҡлығы",
  "item.minecraft.diamond_chestplate": "алмас күкрәксә□□тәндә:□+8 ҡояҡ□+2 ҡояҡ ныҡлығы",
  "item.minecraft.diamond_leggings": "алмаслы салбар□□аяҡта:□+6 ҡояҡ□+2 ҡояҡ ныҡлығы",
  "item.minecraft.diamond_boots": "алмаслы итек□□үксәлә:□+3 ҡояҡ□+2 ҡояҡ ныҡлығы",
  "item.minecraft.golden_helmet": "алтын торҡа□□башта:□+2 ҡояҡ",
  "item.minecraft.golden_chestplate": "алтын күкрәксә□□тәндә:□+5 ҡояҡ",
  "item.minecraft.golden_leggings": "алтын салбар□□аяҡта:□+3 ҡояҡ",
  "item.minecraft.golden_boots": "алтын итек□□үксәлә:□+1 ҡояҡ",
  "item.minecraft.netherite_helmet": "неҙеритлы торҡа□□башта:□+3 ҡояҡ□+3 ҡояҡ ныҡлығы□+1 ырғытыуға тотҡарлығы",
  "item.minecraft.netherite_chestplate": "неҙеритлы күкрәксә□□тәндә:□+8 ҡояҡ□+3 ҡояҡ ныҡлығы□+1 ырғытыуға тотҡарлығы",
  "item.minecraft.netherite_leggings": "неҙерит салбары□□аяҡта:□+6 ҡояҡ□+3 ҡояҡ ныҡлығы□+1 ырғытыуға тотҡарлығы",
  "item.minecraft.netherite_boots": "неҙерит итеге□□үксәлә:□+3 ҡояҡ□+3 ҡояҡ ныҡлығы□+1 ырғытыуға тотҡарлығы",
  "item.minecraft.flint": "саҡматаш",
  "item.minecraft.porkchop": "бешмәгән сусҡа ите",
  "item.minecraft.cooked_porkchop": "ҡурылған сусҡа ите",
  "item.minecraft.painting": "рәсем",
  "item.minecraft.golden_apple": "алтын алма",
  "item.minecraft.enchanted_golden_apple": "сихырлы алтын алма",
  "block.minecraft.oak_sign": "имән яҙмаҡсалығы",
  "block.minecraft.spruce_sign": "шыршы яҙмаҡсалығы",
  "block.minecraft.birch_sign": "ҡайын яҙмаҡсалығы",
  "block.minecraft.jungle_sign": "тропик ағас яҙмаҡсалығы",
  "block.minecraft.acacia_sign": "сәрүәр яҙмаҡсалығы",
  "block.minecraft.dark_oak_sign": "ҡара имән яҙмаҡсалығы",
  "block.minecraft.crimson_sign": "бурлат яҙмаҡсалығы",
  "block.minecraft.warped_sign": "боҙолған яҙмаҡсалығы",
  "item.minecraft.bucket": "биҙрә",
  "item.minecraft.water_bucket": "һыу менән биҙрә",
  "item.minecraft.lava_bucket": "лава менән биҙрә",
  "item.minecraft.minecart": "вагонетка",
  "item.minecraft.saddle": "эйәр",
  "item.minecraft.redstone": "редстоун",
  "item.minecraft.snowball": "ҡар киҫәге",
  "item.minecraft.oak_boat": "имән кәмәһе",
  "item.minecraft.leather": "тир",
  "item.minecraft.milk_bucket": "һөт силәге",
  "item.minecraft.pufferfish_bucket": "энәбалыҡ менән биҙрә",
  "item.minecraft.salmon_bucket": "һөмбаш менән биҙрә",
  "item.minecraft.cod_bucket": "тәрәс менән биҙрә",
  "item.minecraft.tropical_fish_bucket": "тропик балығы менән биҙрә",
  "item.minecraft.brick": "кирбес",
  "item.minecraft.clay_ball": "балсыҡ төйөрө",
  "block.minecraft.dried_kelp_block": "кипкән диңгеҙ кәбеҫтәнең өйөмө",
  "item.minecraft.paper": "ҡағыҙ",
  "item.minecraft.book": "китап",
  "item.minecraft.slime_ball": "лайлас ҡуйырығы",
  "item.minecraft.chest_minecart": "һандыҡ менән вагонетка",
  "item.minecraft.furnace_minecart": "вагонетка мейес менән",
  "item.minecraft.egg": "йомортҡа",
  "item.minecraft.compass": "компас",
  "item.minecraft.fishing_rod": "ҡармаҡ",
  "item.minecraft.clock": "сәғәт",
  "item.minecraft.glowstone_dust": "яҡтыташ саңы",
  "item.minecraft.cod": "бешмәгән тәрәс",
  "item.minecraft.salmon": "бешмәгән һөмбаш",
  "item.minecraft.tropical_fish": "тропик балығы",
  "item.minecraft.pufferfish": "энәбалыҡ",
  "item.minecraft.cooked_cod": "ҡурылған тәрәс",
  "item.minecraft.cooked_salmon": "ҡурылған һөмбаш",
  "item.minecraft.ink_sac": "ҡара тоғо",
  "item.minecraft.red_dye": "ҡыҙыл буяу",
  "item.minecraft.green_dye": "йәшел буяу",
  "item.minecraft.cocoa_beans": "какао-борсаҡтары",
  "item.minecraft.lapis_lazuli": "рәжүәрт",
  "item.minecraft.purple_dye": "шәмәхә буяу",
  "item.minecraft.cyan_dye": "фирүзә буяу",
  "item.minecraft.light_gray_dye": "аҡһыл һоро буяу",
  "item.minecraft.gray_dye": "һоро буяу",
  "item.minecraft.pink_dye": "алһыу буяу",
  "item.minecraft.lime_dye": "йәшкелт буяуыс",
  "item.minecraft.yellow_dye": "һары буяу",
  "item.minecraft.light_blue_dye": "зәңгәр буяу",
  "item.minecraft.magenta_dye": "ҡуйы ҡыҙыл буяу",
  "item.minecraft.orange_dye": "ҡыҙғылт һары буяу",
  "item.minecraft.bone_meal": "һөйәк оно",
  "item.minecraft.blue_dye": "күк буяу",
  "item.minecraft.brown_dye": "көрән буяу",
  "item.minecraft.black_dye": "ҡара буяу",
  "item.minecraft.white_dye": "аҡ буяу",
  "item.minecraft.bone": "һөйәк",
  "item.minecraft.sugar": "шәкәр",
  "block.minecraft.cake": "торт",
  "block.minecraft.white_bed": "аҡ карауат",
  "block.minecraft.orange_bed": "ҡыҙғылт һары карауат",
  "block.minecraft.magenta_bed": "ҡуйы ҡыҙыл карауат",
  "block.minecraft.light_blue_bed": "зәңгәр карауат",
  "block.minecraft.yellow_bed": "һары карауат",
  "block.minecraft.lime_bed": "йәшкелт карауат",
  "block.minecraft.pink_bed": "алһыу карауат",
  "block.minecraft.gray_bed": "һоро карауат",
  "block.minecraft.light_gray_bed": "аҡһыл һоро карауат",
  "block.minecraft.cyan_bed": "фирүзә карауат",
  "block.minecraft.purple_bed": "шәмәхә карауат",
  "block.minecraft.blue_bed": "күк карауат",
  "block.minecraft.brown_bed": "көрән карауат",
  "block.minecraft.green_bed": "йәшел карауат",
  "block.minecraft.red_bed": "ҡыҙыл карауат",
  "block.minecraft.black_bed": "ҡара карауат",
  "item.minecraft.cookie": "печенье",
  "item.minecraft.filled_map": "ерһүрәт□#0",
  "item.minecraft.shears": "ҡайсы",
  "item.minecraft.melon_slice": "ҡарбуз телеме",
  "item.minecraft.dried_kelp": "киптерелгән диңгеҙ кәбеҫтәһе",
  "item.minecraft.pumpkin_seeds": "ҡабаҡ орлоҡтары",
  "item.minecraft.melon_seeds": "ҡарбуз орлоҡтары",
  "item.minecraft.beef": "бешмәгән һыйыр ите",
  "item.minecraft.cooked_beef": "стейк",
  "item.minecraft.chicken": "бешмәгән тауыҡ ите",
  "item.minecraft.cooked_chicken": "ҡурылған тауыҡ ите",
  "item.minecraft.rotten_flesh": "серек ит",
  "item.minecraft.ender_pearl": "эндер-ынйы",
  "item.minecraft.blaze_rod": "ялҡындаҡтың үҙәге",
  "item.minecraft.ghast_tear": "гаст йәше",
  "item.minecraft.gold_nugget": "алтын киҫәге",
  "item.minecraft.nether_wart": "неҙер ҡатламы",
  "item.minecraft.potion": "булдырмай торған эсемлек□йоғонтоһоҙ",
  "item.minecraft.glass_bottle": "бәләкәй шешә",
  "item.minecraft.spider_eye": "үрмәксенең күҙе",
  "item.minecraft.fermented_spider_eye": "маринадланған үрмәксенең күҙе",
  "item.minecraft.blaze_powder": "ялҡындаҡтың онтағы",
  "item.minecraft.magma_cream": "магма ҡуйырығы",
  "block.minecraft.brewing_stand": "эсемлек ҡайнатыу терәге",
  "block.minecraft.cauldron": "ҡаҙан",
  "item.minecraft.ender_eye": "эндер күҙе",
  "item.minecraft.glistering_melon_slice": "ялтырап торған ҡарбуз телеме",
  "item.minecraft.bat_spawn_egg": "ярғанат саҡырыу йомортҡаһы",
  "item.minecraft.bee_spawn_egg": "бал ҡорто саҡырыу йомортҡаһы",
  "item.minecraft.blaze_spawn_egg": "ялҡындаҡ саҡырыу йомортҡаһы",
  "item.minecraft.cat_spawn_egg": "бесәйе саҡырыу йомортҡаһы",
  "item.minecraft.cave_spider_spawn_egg": "мәмерйә үрмәксе саҡырыу йомортҡаһы",
  "item.minecraft.chicken_spawn_egg": "тауыҡ саҡырыу йомортҡаһы",
  "item.minecraft.cod_spawn_egg": "тәрәс саҡырыу йомортҡаһы",
  "item.minecraft.cow_spawn_egg": "һыйыр саҡырыу йомортҡаһы",
  "item.minecraft.creeper_spawn_egg": "крипер саҡырыу йомортҡаһы",
  "item.minecraft.dolphin_spawn_egg": "дельфин саҡырыу йомортҡаһы",
  "item.minecraft.donkey_spawn_egg": "ишәк саҡырыу йомортҡаһы",
  "item.minecraft.drowned_spawn_egg": "батҡын саҡырыу йомортҡаһы",
  "item.minecraft.elder_guardian_spawn_egg": "боронғо һаҡлаусы саҡырыу йомортҡаһы",
  "item.minecraft.enderman_spawn_egg": "эндермен саҡырыу йомортҡаһы",
  "item.minecraft.endermite_spawn_egg": "эндермит саҡырыу йомортҡаһы",
  "item.minecraft.evoker_spawn_egg": "арбаусы саҡырыу йомортҡаһы",
  "item.minecraft.fox_spawn_egg": "төлкө саҡырыу йомортҡаһы",
  "item.minecraft.ghast_spawn_egg": "гаст саҡырыу йомортҡаһы",
  "item.minecraft.guardian_spawn_egg": "һаҡлаусы саҡырыу йомортҡаһы",
  "item.minecraft.hoglin_spawn_egg": "һоглиң саҡырыу йомортҡаһы",
  "item.minecraft.horse_spawn_egg": "ат саҡырыу йомортҡаһы",
  "item.minecraft.husk_spawn_egg": "үлек саҡырыу йомортҡаһы",
  "item.minecraft.llama_spawn_egg": "лама саҡырыу йомортҡаһы",
  "item.minecraft.magma_cube_spawn_egg": "магма кубы саҡырыу йомортҡаһы",
  "item.minecraft.mooshroom_spawn_egg": "муурҡышы саҡырыу йомортҡаһы",
  "item.minecraft.mule_spawn_egg": "ҡасыр саҡырыу йомортҡаһы",
  "item.minecraft.ocelot_spawn_egg": "оцелот саҡырыу йомортҡаһы",
  "item.minecraft.panda_spawn_egg": "панда саҡырыу йомортҡаһы",
  "item.minecraft.parrot_spawn_egg": "тутыйғош саҡырыу йомортҡаһы",
  "item.minecraft.phantom_spawn_egg": "өйрәк саҡырыу йомортҡаһы",
  "item.minecraft.pig_spawn_egg": "сусҡа саҡырыу йомортҡаһы",
  "item.minecraft.piglin_spawn_egg": "пиглиң саҡырыу йомортҡаһы",
  "item.minecraft.pillager_spawn_egg": "башкиҫәр саҡырыу йомортҡаһы",
  "item.minecraft.polar_bear_spawn_egg": "аҡ айыу саҡырыу йомортҡаһы",
  "item.minecraft.pufferfish_spawn_egg": "энәбалыҡ саҡырыу йомортҡаһы",
  "item.minecraft.rabbit_spawn_egg": "ҡуян саҡырыу йомортҡаһы",
  "item.minecraft.ravager_spawn_egg": "бөлдөрөүсе саҡырыу йомортҡаһы",
  "item.minecraft.salmon_spawn_egg": "һөмбаш саҡырыу йомортҡаһы",
  "item.minecraft.sheep_spawn_egg": "һарыҡ саҡырыу йомортҡаһы",
  "item.minecraft.shulker_spawn_egg": "шалкер саҡырыу йомортҡаһы",
  "item.minecraft.silverfish_spawn_egg": "ҡуңыҙҡорт саҡырыу йомортҡаһы",
  "item.minecraft.skeleton_spawn_egg": "һөлдә саҡырыу йомортҡаһы",
  "item.minecraft.skeleton_horse_spawn_egg": "һөлдә ат саҡырыу йомортҡаһы",
  "item.minecraft.slime_spawn_egg": "лайлас саҡырыу йомортҡаһы",
  "item.minecraft.spider_spawn_egg": "үрмәксе саҡырыу йомортҡаһы",
  "item.minecraft.squid_spawn_egg": "һигеҙаяҡ саҡырыу йомортҡаһы",
  "item.minecraft.stray_spawn_egg": "сырғыя саҡырыу йомортҡаһы",
  "item.minecraft.strider_spawn_egg": "бойоҡсо саҡырыу йомортҡаһы",
  "item.minecraft.trader_llama_spawn_egg": "сәүҙәгәрҙең ламаһы саҡырыу йомортҡаһы",
  "item.minecraft.tropical_fish_spawn_egg": "тропик балыҡ саҡырыу йомортҡаһы",
  "item.minecraft.turtle_spawn_egg": "гөбөргәйел саҡырыу йоморотҡаһы",
  "item.minecraft.vex_spawn_egg": "ҡоротҡос саҡырыу йомортҡаһы",
  "item.minecraft.villager_spawn_egg": "тороусы саҡырыу йомортҡаһы",
  "item.minecraft.vindicator_spawn_egg": "көрәшсе саҡырыу йомортҡаһы",
  "item.minecraft.wandering_trader_spawn_egg": "гиҙеүсе сәүҙәгәр саҡырыу йомортҡаһы",
  "item.minecraft.witch_spawn_egg": "мауыҙ саҡырыу йомортҡаһы",
  "item.minecraft.wither_skeleton_spawn_egg": "визер-һөлдә саҡырыу йомортҡаһы",
  "item.minecraft.wolf_spawn_egg": "бүре саҡырыу йомортҡаһы",
  "item.minecraft.zoglin_spawn_egg": "зоглиң саҡырыу йомортҡаһы",
  "item.minecraft.zombie_spawn_egg": "зомби саҡырыу йомортҡаһы",
  "item.minecraft.zombie_horse_spawn_egg": "зомби ат саҡырыу йомортҡаһы",
  "item.minecraft.zombie_villager_spawn_egg": "зомби-тороусы саҡырыу йомортҡаһы",
  "item.minecraft.zombified_piglin_spawn_egg": "зомбиланған пиглиң саҡырыу йомортҡаһы",
  "item.minecraft.experience_bottle": "сихырлы шешә",
  "item.minecraft.fire_charge": "ялҡын яһағы",
  "item.minecraft.writable_book": "китап һәм ҡәләм",
  "item.minecraft.written_book": "яҙылған китап",
  "item.minecraft.emerald": "зөбәржәт",
  "item.minecraft.item_frame": "ҡыҫан",
  "block.minecraft.flower_pot": "сәскә көршәге",
  "item.minecraft.carrot": "кишер",
  "item.minecraft.potato": "бәрәңге",
  "item.minecraft.baked_potato": "бешерелгән бәрәңге",
  "item.minecraft.poisonous_potato": "ағыулы бәрәңге",
  "item.minecraft.map": "буш ерһүрәт",
  "item.minecraft.golden_carrot": "алтын кишер",
  "block.minecraft.skeleton_skull": "һөлдә башы",
  "block.minecraft.wither_skeleton_skull": "визер-һөлдә башы",
  "block.minecraft.player_head": "уйынсының бышы",
  "block.minecraft.zombie_head": "зомби башы",
  "block.minecraft.creeper_head": "крипер башы",
  "block.minecraft.dragon_head": "аждаһа башы",
  "item.minecraft.carrot_on_a_stick": "кишерле ҡармаҡ",
  "item.minecraft.warped_fungus_on_a_stick": "боҙолған бәшмәк менән ҡармаҡ",
  "item.minecraft.nether_star": "неҙер йондоҙо",
  "item.minecraft.pumpkin_pie": "ҡабаҡ бәлеше",
  "item.minecraft.firework_rocket": "фейерверк",
  "item.minecraft.firework_star": "фейерверк йондоҙо",
  "item.minecraft.enchanted_book": "сихырлы китап",
  "item.minecraft.nether_brick": "неҙер кирбесе",
  "item.minecraft.quartz": "неҙер-кварц",
  "item.minecraft.tnt_minecart": "динамитлы вагонетка",
  "item.minecraft.hopper_minecart": "вагонетка буранка менән",
  "item.minecraft.prismarine_shard": "призмарин ярсығы",
  "item.minecraft.prismarine_crystals": "призмарин кристалы",
  "item.minecraft.rabbit": "бешмәгән ҡуян ите",
  "item.minecraft.cooked_rabbit": "ҡурылған ҡуян ите",
  "item.minecraft.rabbit_stew": "быҡтырылған ҡуян",
  "item.minecraft.rabbit_foot": "ҡуян тәпәйе",
  "item.minecraft.rabbit_hide": "ҡуян тиреһе",
  "item.minecraft.armor_stand": "ҡояҡ терәге",
  "item.minecraft.iron_horse_armor": "аттың тимер ҡояғы",
  "item.minecraft.golden_horse_armor": "аттың алтын ҡояғы",
  "item.minecraft.diamond_horse_armor": "ат алмас ҡояғы",
  "item.minecraft.leather_horse_armor": "ат күн ҡалҡаны",
  "item.minecraft.lead": "сылбыр",
  "item.minecraft.name_tag": "ярлыҡ",
  "item.minecraft.command_block_minecart": "бойороҡ блоклы вагонетка",
  "item.minecraft.mutton": "бешмәгән һарыҡ ите",
  "item.minecraft.cooked_mutton": "ҡурылған һарыҡ ите",
  "block.minecraft.white_banner": "аҡ байраҡ",
  "block.minecraft.orange_banner": "ҡыҙғылт һары байраҡ",
  "block.minecraft.magenta_banner": "ҡуйы ҡыҙыл байраҡ",
  "block.minecraft.light_blue_banner": "зәңгәр байраҡ",
  "block.minecraft.yellow_banner": "һары байраҡ",
  "block.minecraft.lime_banner": "йәшкелт байраҡ",
  "block.minecraft.pink_banner": "алһыу байраҡ",
  "block.minecraft.gray_banner": "һоро байраҡ",
  "block.minecraft.light_gray_banner": "аҡһыл һоро байраҡ",
  "block.minecraft.cyan_banner": "фирүзә байраҡ",
  "block.minecraft.purple_banner": "шәмәхә байраҡ",
  "block.minecraft.blue_banner": "күк байраҡ",
  "block.minecraft.brown_banner": "көрән байраҡ",
  "block.minecraft.green_banner": "йәшел байраҡ",
  "block.minecraft.red_banner": "ҡыҙыл байраҡ",
  "block.minecraft.black_banner": "ҡара байраҡ",
  "item.minecraft.end_crystal": "энд кристаллы",
  "item.minecraft.chorus_fruit": "хорус емеше",
  "item.minecraft.popped_chorus_fruit": "ҡурылған хорус емеше",
  "item.minecraft.beetroot": "сөгөлдөр",
  "item.minecraft.beetroot_seeds": "сөгөлдөр орлоҡтары",
  "item.minecraft.beetroot_soup": "сөгөлдөр һурпаһы",
  "item.minecraft.dragon_breath": "аждаһа тыны",
  "item.minecraft.splash_potion": "шарлай торған булдырмаған эсемлек□йоғонтоһоҙ",
  "item.minecraft.spectral_arrow": "спектраль уғы",
  "item.minecraft.tipped_arrow": "булдырмай торған эсемлек менән эшкәртергән уғы□йоғонтоһоҙ",
  "item.minecraft.lingering_potion": "томанлы булдырмай торған эсемелге□йоғонтоһоҙ",
  "item.minecraft.shield": "ҡалҡан",
  "item.minecraft.elytra": "элитралар",
  "item.minecraft.spruce_boat": "шыршы кәмәһе",
  "item.minecraft.birch_boat": "ҡайын кәмәһе",
  "item.minecraft.jungle_boat": "тропик ағас кәмәһе",
  "item.minecraft.acacia_boat": "сәрүәр кәмәһе",
  "item.minecraft.dark_oak_boat": "ҡара имән кәмәһе",
  "item.minecraft.totem_of_undying": "үлемһеҙлек тотемы",
  "item.minecraft.shulker_shell": "шалкер ҡабығы",
  "item.minecraft.iron_nugget": "тимерҙең киҫәге",
  "item.minecraft.knowledge_book": "белем китабы",
  "item.minecraft.debug_stick": "төҙәтеү таяҡсаһы",
  "item.minecraft.music_disc_13": "пластинка□c418 — 13",
  "item.minecraft.music_disc_cat": "пластинка□c418 — cat",
  "item.minecraft.music_disc_blocks": "пластинка□c418 — blocks",
  "item.minecraft.music_disc_chirp": "пластинка□c418 — chirp",
  "item.minecraft.music_disc_far": "пластинка□c418 — far",
  "item.minecraft.music_disc_mall": "пластинка□c418 — mall",
  "item.minecraft.music_disc_mellohi": "пластинка□c418 — mellohi",
  "item.minecraft.music_disc_stal": "пластинка□c418 — stal",
  "item.minecraft.music_disc_strad": "пластинка□c418 — strad",
  "item.minecraft.music_disc_ward": "пластинка□c418 — ward",
  "item.minecraft.music_disc_11": "пластинка□c418 — 11",
  "item.minecraft.music_disc_wait": "пластинка□c418 — wait",
  "item.minecraft.music_disc_pigstep": "пластинка□лина рейн — pigstep",
  "item.minecraft.trident": "өс теш□□төп ҡулда:□+8 зыян□-2.9 һөжүм тиҙлек",
  "item.minecraft.phantom_membrane": "өрәк мембранаһы",
  "item.minecraft.nautilus_shell": "наутилус ҡабырсағы",
  "item.minecraft.heart_of_the_sea": "диңгеҙ йөрәге",
  "item.minecraft.crossbow": "арбалет",
  "item.minecraft.suspicious_stew": "серле рагу",
  "block.minecraft.loom": "туҡыу эшкәрлеге",
  "item.minecraft.flower_banner_pattern": "байраҡ биҙәге□сәскә",
  "item.minecraft.creeper_banner_pattern": "байраҡ биҙәге□крипер",
  "item.minecraft.skull_banner_pattern": "байраҡ биҙәге□баш һөйәге",
  "item.minecraft.mojang_banner_pattern": "байраҡ биҙәге□бер нәмә",
  "item.minecraft.globe_banner_pattern": "байраҡ биҙәге□глобус",
  "item.minecraft.piglin_banner_pattern": "байраҡ биҙәге□томшоҡ",
  "block.minecraft.composter": "серемдек",
  "block.minecraft.barrel": "сапсаҡ",
  "block.minecraft.smoker": "ыҫҡарғы",
  "block.minecraft.blast_furnace": "иреткес мейес",
  "block.minecraft.cartography_table": "картограф өҫтәле",
  "block.minecraft.fletching_table": "йәйәүсенең өҫтәле",
  "block.minecraft.grindstone": "ҡайраҡ",
  "block.minecraft.lectern": "кафедра",
  "block.minecraft.smithing_table": "тимерсенең өҫтәле",
  "block.minecraft.stonecutter": "ташкиҫкес",
  "block.minecraft.bell": "ҡаңғырау",
  "block.minecraft.lantern": "шәм",
  "block.minecraft.soul_lantern": "йәнле шәм",
  "item.minecraft.sweet_berries": "татлы емештәр",
  "block.minecraft.campfire": "усаҡ",
  "block.minecraft.soul_campfire": "йән усағы",
  "block.minecraft.shroomlight": "нурбәшмәк",
  "item.minecraft.honeycomb": "ҡорт кәрәҙҙәре",
  "block.minecraft.bee_nest": "бал ҡорто ояһы",
  "block.minecraft.beehive": "умарта",
  "item.minecraft.honey_bottle": "бал шешәһе",
  "block.minecraft.honey_block": "бал ҡорамаһы",
  "block.minecraft.honeycomb_block": "бал ҡортоларҙың кәрәҙ ҡорамаһы",
  "block.minecraft.lodestone": "магнетит",
  "block.minecraft.netherite_block": "неҙерит ҡорамаһы",
  "block.minecraft.ancient_debris": "боронғо вайранлыҡтар",
  "block.minecraft.target": "сәп",
  "block.minecraft.crying_obsidian": "илау обсидианы",
  "block.minecraft.blackstone": "ҡараташ",
  "block.minecraft.blackstone_slab": "ҡараташ плитаһы",
  "block.minecraft.blackstone_stairs": "ҡараташ баҫҡыстары",
  "block.minecraft.gilded_blackstone": "алтынланған ҡараташ",
  "block.minecraft.polished_blackstone": "шымартылған ҡараташ",
  "block.minecraft.polished_blackstone_slab": "шымартылған ҡараташ плитаһы",
  "block.minecraft.polished_blackstone_stairs": "шымартылған ҡараташ баҫҡыстары",
  "block.minecraft.chiseled_polished_blackstone": "семәрле шымартылған ҡараташ",
  "block.minecraft.polished_blackstone_bricks": "шымартылған ҡараташ кирбестәре",
  "block.minecraft.polished_blackstone_brick_slab": "шымартылған ҡараташ кирбес плитаһы",
  "block.minecraft.polished_blackstone_brick_stairs": "шымартылған ҡараташ кирбес баҫҡыстары",
  "block.minecraft.cracked_polished_blackstone_bricks": "ярылған шымартылған ҡараташ кирбестәре",
  "block.minecraft.respawn_anchor": "тергеҙеү якоры",
}
export const ba_ru = items; 
